// extracted by mini-css-extract-plugin
export default {"btn":"PricingButton_btn__hzoME","btnPrimary":"PricingButton_btnPrimary__Nb1ZU","btnGhost":"PricingButton_btnGhost__6y-dM"};